import React from "react";

import ProfileDetailsSection from "./ProfileDetailsSection";
import ProfileInfoSection from "./ProfileInfoSection";

const ProfileInfoTab = () => {
  return (
    <div>
      <ProfileDetailsSection />
      <ProfileInfoSection />
    </div>
  );
};

export default ProfileInfoTab;
